import config from "../../config.json"
import { useLanguage } from "../../contexts/LanguageContext"

const tabKeyToTranslation = {
  Couleurs: "colors",
  Textes: "texts",
  Icônes: "icons",
  Divers: "misc",
}

/**
 * Renders tab navigation with active state management.
 * @param {Object} props
 * @param {Object} props.parameters - Current parameters state
 * @param {Function} props.setParameters - Function to update parameters
 * @returns {JSX.Element}
 */
function Tabs({ parameters, setParameters }) {
  const { t } = useLanguage()

  if (!parameters) {
    return <div id="tabs" className="mx-auto" />
  }

  /**
   * Determines if a tab should be highlighted as active.
   * @param {string} tab - Tab key
   * @returns {string} CSS class for active or inactive tab
   */
  function getClass(tab) {
    return parameters.selectedTab === tab ? "nav-link active" : "nav-link"
  }

  /**
   * Switches to a different tab and updates the UI state.
   * @param {string} tab - Tab key to switch to
   */
  function setParametersTab(tab) {
    if (setParameters) {
      setParameters({ ...parameters, selectedTab: tab })
    }
  }

  return (
    <div id="tabs" className="mx-auto">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        {Object.keys(config.tabContent).map(key => (
          <li className="nav-item" key={key}>
            <a className={getClass(key)} id={`${key}-tab`} data-toggle="tab" href={`#${key}`} role="tab" onClick={() => setParametersTab(key)}>
              {typeof t === "function" ? t(`Tabs.${tabKeyToTranslation[key]}`) : `Tabs.${tabKeyToTranslation[key]}`}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Tabs
